import React from 'react';
import { Container, Button } from "shards-react";
import logo from '../assets/images/vibinoLogo.svg';
import LoginForm from '../components/Login/LoginForm'



const Login = () => (
    <Container fluid className="main-content-container px-4 pb-4">
        <div className="login">
            <div className="login__content">
                <div className="header">
                    <img className="logo" src={logo} alt="Vibino" />
                    <h3>Operator Panel</h3>
                </div>
                {/* <div className="form-group"> */}
                {/* <label for="exampleInputEmail1">Username</label> */}
                {/* <input placeholder="Username" type="email" className="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" /> */}
                {/* </div> */}
                {/* <div className="form-group"> */}
                {/* <label for="exampleInputPassword1">Password</label> */}
                {/* <input placeholder="Password" type="password" className="form-control" id="exampleInputPassword1" /> */}
                {/* </div> */}
                <LoginForm />
                {/* <button type="submit" className="btn btn-primary">Submit</button> */}
            </div>
        </div>
    </Container>
);

export default Login;
